// extracted by mini-css-extract-plugin
export default {"section":"ProgramExpensesSection_section__Ive3u","loader-container":"ProgramExpensesSection_loader-container__XsuPs","filters":"ProgramExpensesSection_filters__2KPVJ"};